import React from 'react';

import { Stack, Box } from '@atlaskit/primitives/compiled';

import type { Snippet } from '../types/snippet.ts';

import { SnippetPanelItem } from './snippet-panel-item/SnippetPanelItem.tsx';
import { useSnippetPopupPreview } from './preview/SnippetPopupPreviewContext.tsx';

type SnippetPanelListProps = {
	snippets: Snippet[];
	contentId: string;
	spaceId: string;
	spaceKey: string;
};

export const SnippetPanelList = ({
	snippets,
	contentId,
	spaceId,
	spaceKey,
}: SnippetPanelListProps) => {
	const { hidePreview } = useSnippetPopupPreview();

	return (
		<Box onMouseLeave={hidePreview}>
			<Stack>
				{snippets?.map((snippet) => (
					<SnippetPanelItem
						key={snippet.snippetId}
						snippet={snippet}
						contentId={contentId}
						spaceId={spaceId}
						spaceKey={spaceKey}
					/>
				))}
			</Stack>
		</Box>
	);
};
